import styled from "styled-components";
import { colors, device } from "../../utils";

const Wrapper
	= styled.div`

		@media ${device.tabletPDown} {
			flex-direction: column;
			gap: calc(18px + .8vw);

			.left-wrapper {
				order: 2;
			}
			.right-wrapper {
				order: 1;
			}
		}
		@media ${device.tabletLUp} {
			flex-direction: row;
			gap: calc(4px + .4vw);

			.left-wrapper {
				order: 1;
			}
			.right-wrapper {
				order: 2;
			}
		}

		display: flex;

		.left-wrapper {
			@media ${device.tabletLUp} {
				max-height: 80vh;
			}
			@media ${device.tabletPDown} {
				max-height: 35vh;
			}
			flex: 1;
			display: flex;
			flex-direction: column;
			gap: calc(4px + .4vw);
			overflow: auto;

			&::-webkit-scrollbar {
				width: 5px;
			}

			/* Track */
			&::-webkit-scrollbar-track {
				background: rgba(255,255,255, .1);
				border-radius: 20px;
			}

			/* Handle */
			&::-webkit-scrollbar-thumb {
				background: ${colors.info};
				border-radius: 20px;
			}
		}

		.right-wrapper {
			@media ${device.tabletLUp} {
				min-height: 80vh;
			}

			@media ${device.tabletPDown} {
				height: auto;
			}
			flex: 2;
			display: flex;
			justify-content: center;

			.content-wrapper {
				display: flex;
				flex-direction: column;
				width: calc(310px + 17vw);
				gap: calc(10px + .8vw);

				.img-container {
					position: relative;
					width: 100%;
					height: calc(310px + 17vw);
					border: 1px solid white;

					display: flex;
					justify-content: center;
					align-items: center;
					background-color: ${colors.defaultImage};

					img {
						position: absolute;
						width: 100%;
						bottom: 0;

						&.background {
							z-index: 1;
							height: 100%;
						}
						&.base {
							z-index: 2;
						}
						&.eyes {
							z-index: 3;
						}
						&.outfit {
							z-index: 4;
						}
						&.mouth {
							z-index: 5;
						}
						&.headgear {
							z-index: 6;
						}
					}
				}

				.user-selection {
					display: flex;
					flex-wrap: wrap;
					gap: calc(4px + .4vw);

					.selection {
						display: flex;
						justify-content: space-between;
						align-items: center;
						gap: calc(8px + .8vw);
						padding: calc(2px + .2px) calc(4px + .4vw);
						border-radius: 999px;
						background-color: rgba(255,255,255, .1);
						color: white;
						cursor: pointer;
						transition: .2s ease;

						svg {
							font-size: 115%;
						}

						&:hover {
							background-color: white;
							color: black;

							svg {
								color: ${colors.danger};
							}
						}
					}
				}
				.button-container {
					display: flex;
					gap: calc(4px + .4vw);
					width: 100%;

					> button {
						flex: 1;
					}
				}
			}
		}
	`

export default Wrapper
